:host {
  display: contents;
}